import { render } from "./ToStartResults.vue?vue&type=template&id=2e86f57c"
import script from "./ToStartResults.vue?vue&type=script&lang=js"
export * from "./ToStartResults.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/results/ToStartResults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e86f57c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e86f57c', __exports__)) {
    console.log('reload')
    api.reload('2e86f57c', __exports__)
  }
  
  module.hot.accept("./ToStartResults.vue?vue&type=template&id=2e86f57c", () => {
    console.log('re-render')
    api.rerender('2e86f57c', render)
  })

}


export default __exports__